export const FIND_CUSTOMER = 'Favorite/Customer/FIND_CUSTOMER';

export const FIND_CUSTOMER_SUCCESS = 'Favorite/Customer/FIND_CUSTOMER_SUCCESS';

export const FIND_CUSTOMER_ERROR = 'Favorite/Customer/FIND_CUSTOMER_ERROR';

export const CLEAR_CUSTOMER = 'Favorite/Customer/CLEAR_CUSTOMER';
